<template>
  <van-cell-group :class="{ modeFile: true, detail: type == 'detail' }">
    <van-field
      v-if="type == 'apply'"
      input-align="right"
      label="上传附件"
      readonly
      :required="fjsfbt === '1'"
    >
      <template #input>
        <van-uploader
          :preview-image="false"
          v-model="filesList"
          :after-read="afterRead"
        >
          <div class="fujianImg"></div>
        </van-uploader>
      </template>
    </van-field>

    <van-field
      v-for="(item, index) in filesList"
      :key="index"
      input-align="right"
      readonly
    >
      <template #label>
        <div class="file_header">
          <span class="file_img"></span>
          <div class="file_info">
            <h3>{{ item.file.name }}</h3>
            <!-- <p>{{ (file.file.size / 1024).toFixed(2) }}KB</p> -->
          </div>
        </div>
      </template>
      <template #input>
        <van-icon name="cluster" @click="download(item.file)" />
      </template>
    </van-field>
  </van-cell-group>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  props: {
    type: {
      type: String,
      default: "apply"
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fileList: {
      handler(newVal) {
        this.filesList = newVal.map(item => {
          return {
            file: {
              name: item.fj_name,
              id:item.xs0702_fjid
            }
          };
        });
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      fjsfbt: "",
      filesList: []
    };
  },
  methods: {
    async download(file) {
      const res = await Api.fileDownload({
        xs0702fjidid: file.id
      });
      if (res.code && res.code == "0") {
        this.$toast("下载失败！");
      } else {
        const href = URL.createObjectURL(res);
        const a = document.createElement("a");
        a.download = file.name;
        a.href = href;
        a.click();
      }
    },
    afterRead(file, detail) {
      console.log(this.filesList);
    }
  }
};
</script>
<style lang="less" scoped>
.modeFile {
  margin-bottom: 0 !important;
  &.detail {
    .van-cell {
      padding: 14px 0 !important;
      &::after {
        right: 0 !important;
        left: 0 !important;
      }
    }
  }
  /deep/.van-cell {
    align-items: center;
    .van-field__label {
      width: calc(~"100% - 30px");
    }
    .van-icon {
      color: #b2b2b2;
      font-size: 16px;
    }
  }
  .file_header {
    display: flex;
    align-items: center;
    width: 100%;
    .file_img {
      background: url(../../../../../assets/images/file.png) no-repeat center;
      background-size: 100% 100%;
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .file_info {
      width: calc(~"100% - 40px");

      display: flex;
      flex-direction: column;
      h3 {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        white-space: nowrap;
        line-height: 19px;
      }
      p {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #b2b2b2;
        font-weight: 400;
        margin-top: 2px;
        line-height: 16px;
      }
    }
  }
  .fujianImg {
    background: url(../../../../../assets/images/fujian.png) no-repeat center;
    background-size: 100% 100%;
    width: 18px;
    height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/mode/modeFile.vue